

export const topNews2 = [{
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202306/modi_shah_nadda-sixteen_nine.jpg?size=948:533",
        category: "मध्य प्रदेश",
        title: "बीजेपी संगठन महामंत्री हितानंद शर्मा की अहम बैठक, चुनाव तैयारियों पर चर्चा",
        author: "संजय गुप्ता",
        date: "03 जन 2026 19:36 IST",
        readTime: "2 मिनट पढ़ें",
        fullNews: `दिल्ली और इंदौर के बीच बीजेपी संगठन स्तर पर गतिविधियां तेज हो गई हैं।
बैठक में आगामी चुनावों और संगठनात्मक मजबूती पर चर्चा हुई।
वरिष्ठ नेताओं के साथ बैठकों का दौर जारी है।`,
        link: "/mp",
    },
    {
        image: "https://images.moneycontrol.com/static-mcnews/2024/05/20240502115944_200241-yzevpqohut-1713861432-1-770x404.jpeg?impolicy=website&width=770&height=431",
        category: "राजनीति",
        title: "2026 चुनावों से पहले बीजेपी की रणनीति, संगठन में बदलाव संभव",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `2026 विधानसभा चुनावों से पहले बीजेपी संगठन में बदलाव की चर्चाएं तेज हो गई हैं।
सूत्रों के अनुसार, कई जिलों में नई जिम्मेदारियां दी जा सकती हैं।`,
    },
    {
        image: "https://th-i.thgim.com/public/incoming/xy2ju0/article67931771.ece/alternates/FREE_1200/PTI03_09_2024_000073B.jpg",
        category: "विश्व",
        title: "ग्लोबल मार्केट में उछाल, सेंसेक्स रिकॉर्ड स्तर पर",
        author: "बिजनेस डेस्क",
        date: "04 जन 2026 10:30 IST",
        readTime: "4 मिनट पढ़ें",
        fullNews: `शेयर बाजार ने आज नए रिकॉर्ड स्थापित किए हैं।
वैश्विक संकेतों के कारण निवेशकों में उत्साह देखा जा रहा है।`,
    },
    {
        image: "https://ichef.bbci.co.uk/ace/ws/640/cpsprodpb/1747/live/d9bf1190-c721-11ee-baf9-679cc8378c25.jpg.webp",
        category: "खेल",
        title: "भारतीय क्रिकेट टीम का शानदार प्रदर्शन, सीरीज पर कब्जा",
        author: "स्पोर्ट्स डेस्क",
        date: "04 जन 2026 21:00 IST",
        readTime: "2 मिनट पढ़ें",
        fullNews: `भारत ने निर्णायक मैच में शानदार जीत हासिल की है।
युवा खिलाड़ियों का प्रदर्शन बेहद शानदार रहा।`,
    },
];

export const topNews = [{
        image: "https://th-i.thgim.com/public/incoming/xy2ju0/article67931771.ece/alternates/FREE_1200/PTI03_09_2024_000073B.jpg",
        category: "मध्य प्रदेश",
        title: "मध्य प्रदेश की राजनीति में नए समीकरण, कई सीटों पर बदलाव की संभावना",
        author: "न्यूज़ डेस्क",
        date: "03 जन 2026 17:45 IST",
        readTime: "2 मिनट पढ़ें",
        fullNews: `मध्य प्रदेश की राजनीति में नए समीकरण उभर रहे हैं। आगामी विधानसभा चुनावों को ध्यान में रखते हुए बीजेपी और कांग्रेस दोनों ने अपनी रणनीतियों में बड़े बदलाव किए हैं। कुछ प्रमुख क्षेत्रों में नए और युवा चेहरों को मौका मिलने की जोरदार चर्चा है, जिससे दिग्गज नेताओं की चिंता बढ़ गई है।`,
    },
    {
        image: "https://ichef.bbci.co.uk/ace/ws/640/cpsprodpb/1747/live/d9bf1190-c721-11ee-baf9-679cc8378c25.jpg.webp",
        category: "मध्य प्रदेश",
        title: "चुनावी हलचल तेज, कई सीटों पर उम्मीदवार बदलने की अटकलें",
        author: "न्यूज़ डेस्क",
        date: "03 जन 2026 17:45 IST",
        readTime: "2 मिनट पढ़ें",
        fullNews: `राज्य में चुनावी हलचल काफी तेज हो गई है। राजनीतिक दल कई महत्वपूर्ण सीटों पर नए नामों पर विचार कर रहे हैं। वर्तमान विधायकों के प्रदर्शन की समीक्षा के बाद, आलाकमान ने फैसला किया है कि केवल जीतने वाले चेहरों को ही प्राथमिकता दी जाएगी, जिससे टिकट कटने का डर पैदा हो गया है।`,
    },
    {
        image: "https://staticimg.amarujala.com/assets/images/2025/12/28/lsa-mahanathashaka-o-pa-saha-karanal-ka-mathhabna-ma-madaya-paratanathhaya-sa-makhatab-hata-hae_d2b3fb467b800e33c38c09c299f22c08.jpeg?w=414&dpr=1.0&q=80",
        category: "मध्य प्रदेश",
        title: "राज्य की राजनीति में हलचल, रणनीति पर मंथन जारी",
        author: "न्यूज़ डेस्क",
        date: "03 जन 2026 17:45 IST",
        readTime: "2 मिनट पढ़ें",
        fullNews: `राजनीतिक दल लगातार अपनी चुनावी रणनीतियों को लेकर अहम बैठकें कर रहे हैं। आगामी चुनावों को लेकर नेताओं की सक्रियता काफी बढ़ गई है। बूथ स्तर पर कार्यकर्ताओं को मजबूत करने के लिए विशेष अभियान चलाए जा रहे हैं ताकि चुनावों के दौरान मतदाताओं को आसानी से लुभाया जा सके।`,
    },
    {
        image: "https://www.jagranimages.com/images/newimg/03092025/03_09_2025-bjp_meeting_24034886.webp",
        category: "राजनीति",
        title: "चुनावों से पहले संगठनात्मक बदलाव, बीजेपी में मंथन",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `चुनावों से ठीक पहले संगठनात्मक स्तर पर बड़े बदलाव की संभावना है। पार्टी सूत्रों के मुताबिक, आलाकमान जल्द ही कुछ कड़े फैसले ले सकता है। राज्य कार्यकारिणी में नए लोगों को शामिल करने और निष्क्रिय पदाधिकारियों को हटाने की योजना पर तेजी से काम चल रहा है।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202407/66a5cbe278c52-bjp-cms-meet-284105115-16x9.png?size=948:533",
        category: "राजनीति",
        title: "बीजेपी में संगठन को मजबूत करने पर जोर",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `पार्टी का शीर्ष नेतृत्व संगठन को जमीनी स्तर पर और मजबूत करने पर पूरी तरह से केंद्रित है। विभिन्न जिलों में बैठकों और समीक्षाओं का दौर लगातार जारी है। पार्टी अध्यक्ष ने स्पष्ट किया है कि संगठन की मजबूती ही आगामी चुनावों में जीत का सबसे बड़ा आधार होगी।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202201/bjp_1-sixteen_nine-sixteen_nine.jpg",
        category: "राजनीति",
        title: "आगामी चुनावों के लिए पार्टी की रणनीति तैयार",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `आगामी चुनावों को ध्यान में रखते हुए एक व्यापक रणनीति तैयार की गई है। राज्य और जिला स्तर पर बैठकों का दौर जारी है। जनता से सीधे जुड़ने के लिए विशेष जनसंपर्क अभियान शुरू किए जा रहे हैं, ताकि सरकार की उपलब्धियों को हर घर तक प्रभावी ढंग से पहुंचाया जा सके।`,
    },
];

export const mpNews = [{
        image: "https://www.jagranimages.com/images/newimg/09052024/09_05_2024-voters_women_23714545.webp",
        category: "मध्य प्रदेश",
        title: "इंदौर में शांतिपूर्ण मतदान, प्रशासन संतुष्ट",
        author: "अमित पटेल",
        date: "02 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `इंदौर में मतदान शांतिपूर्ण ढंग से संपन्न हुआ।
प्रशासन ने सुरक्षा व्यवस्था को लेकर संतोष व्यक्त किया है।`,
    },
    {
        image: "https://imgs.etvbharat.com/etvbharat/prod-images/04-03-2025/1200-675-23665940-thumbnail-16x9-mohan.jpg",
        category: "मध्य प्रदेश",
        title: "भोपाल में कैबिनेट की बैठक, नई योजनाओं पर चर्चा",
        author: "सिटी डेस्क",
        date: "02 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `भोपाल में हुई बैठक में विकास योजनाओं पर चर्चा की गई।
सरकार ने और तेज गति से काम करने के संकेत दिए हैं।`,
    },
    {
        image: "https://img-cdn.publive.online/fit-in/640x430/filters:format(webp)/bansal-news/media/media_files/2025/12/18/up-school-timing-change-2025-12-18-10-13-07.jpg",
        category: "मध्य प्रदेश",
        title: "ग्वालियर-चंबल में ठंड का प्रकोप, स्कूलों का समय बदला",
        author: "स्थानीय रिपोर्टर",
        date: "01 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `तापमान में गिरावट के कारण ठंड बढ़ गई है।
प्रशासन ने स्कूलों के समय में बदलाव किया है।`,
    },
    {
        image: "https://staticimg.amarujala.com/assets/images/2025/12/28/lsa-mahanathashaka-o-pa-saha-karanal-ka-mathhabna-ma-madaya-paratanathhaya-sa-makhatab-hata-hae_d2b3fb467b800e33c38c09c299f22c08.jpeg?w=414&dpr=1.0&q=80",
        category: "मध्य प्रदेश",
        title: "उज्जैन के महाकाल लोक में नई सुविधाएं",
        author: "सिटी डेस्क",
        date: "04 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `महाकाल लोक में श्रद्धालुओं के लिए नई सुविधाओं का विस्तार किया गया है।
अब दर्शन व्यवस्था और भी सुलभ हो गई है।`,
    },
];

export const videonews = [{
        image: "https://img.naidunia.com/naidunia/ndnimg/02092024/02_09_2024-mohan_cabinet_3_sep_202492_22258.webp",
        category: "खेल",
        title: "भारत बनाम ऑस्ट्रेलिया: निर्णायक मैच की तैयारी",
        author: "स्पोर्ट्स डेस्क",
        date: "02 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `भारतीय टीम ने निर्णायक मैच के लिए कड़ी प्रैक्टिस की।
मैच में दोनों टीमों के बीच कड़ा मुकाबला होने की उम्मीद है।`,
        videoUrl: "https://youtu.be/CB6sFPV8PdA?si=h6IPVjablK6ZxDUA",
    },
    {
        image: "https://feeds.abplive.com/onecms/images/uploaded-images/2025/12/11/8cb6fe84cca30a2796dbdcbf4b0ce3c41765416329666584_original.jpg?impolicy=abp_cdn&imwidth=1200",
        category: "खेल",
        title: "आईपीएल में बड़े खिलाड़ियों की बोली",
        author: "स्पोर्ट्स रिपोर्टर",
        date: "01 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `आईपीएल नीलामी में कई बड़े खिलाड़ियों की किस्मत का फैसला हुआ।
फ्रेंचाइजी ने युवा खिलाड़ियों पर दांव लगाया।`,
        videoUrl: "https://youtu.be/L7fIF53G_P4?si=ZvRBqkxfTg_9OLnH",
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202407/66a5cbe278c52-bjp-cms-meet-284105115-16x9.png?size=948:533",
        category: "खेल",
        title: "ओलंपिक के लिए खिलाड़ियों का चयन",
        author: "स्पोर्ट्स रिपोर्टर",
        date: "04 जन 2026",
        readTime: "4 मिनट पढ़ें",
        fullNews: `आगामी ओलंपिक के लिए खिलाड़ी चयन प्रक्रिया जारी है।
कई नए चेहरों को मौका मिलने की संभावना है।`,
        videoUrl: "https://youtu.be/CB6sFPV8PdA?si=h6IPVjablK6ZxDUA",
    },
    {
        image: "https://www.jagranimages.com/images/newimg/03092025/03_09_2025-bjp_meeting_24034886.webp",
        category: "खेल",
        title: "टेनिस: ग्रैंड स्लैम में बड़ा उलटफेर",
        author: "स्पोर्ट्स डेस्क",
        date: "03 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `ग्रैंड स्लैम टूर्नामेंट में एक और बड़ा उलटफेर देखने को मिला।
शीर्ष खिलाड़ी टूर्नामेंट से बाहर हो गए हैं।`,
        videoUrl: "https://youtu.be/L7fIF53G_P4?si=ZvRBqkxfTg_9OLnH",
    },
];

export const entertainmentNews = [
    {
        image: "https://www.livehindustan.com/lh-img/smart/img/2025/06/13/1200x900/uttarakhand_rain_1744259893841_1749778376405.jpg",
        category: "मनोरंजन",
        title: "नई बॉलीवुड फिल्म का बॉक्स ऑफिस कलेक्शन",
        author: "एंटरटेनमेंट डेस्क",
        date: "05 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `नई रिलीज हुई फिल्म ने बॉक्स ऑफिस पर धूम मचा दी है।
दर्शक इस फिल्म को काफी पसंद कर रहे हैं।`,
    },
    {
        image: "https://www.livehindustan.com/lh-img/smart/img/2025/02/13/1000x563/board_exam_3_1738383392152_1739457791917.jpg",
        category: "मनोरंजन",
        title: "ओटीटी पर नई वेब सीरीज का ऐलान",
        author: "एंटरटेनमेंट डेस्क",
        date: "04 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `ओटीटी प्लेटफॉर्म पर एक और शानदार वेब सीरीज रिलीज होने जा रही है।
इस सीरीज में कई बड़े सितारे नजर आएंगे।`,
    },
    {
        image: "https://cf-img-a-in.tosshub.com/lingo/nwtak/images/story/202511/6913fdbc6ae21-while-colabas-voter-turnout-was-low--it-still-showed-a-slight-improvement-compared-to-kalyan-west-201209912-16x9.jpeg?size=768:432&q=50",
        category: "मनोरंजन",
        title: "अवॉर्ड शो में सितारों का जमावड़ा",
        author: "एंटरटेनमेंट डेस्क",
        date: "03 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `कल रात हुए अवॉर्ड शो में बॉलीवुड के कई बड़े सितारे पहुंचे।
शो में कई शानदार प्रस्तुतियां भी देखने को मिलीं।`,
    },
    {
        image: "https://qph.cf2.quoracdn.net/main-qimg-445c48edb0461eb1d966801f6da66b2d-lq",
        category: "मनोरंजन",
        title: "इस साल रिलीज होंगी ये बड़ी फिल्में",
        author: "एंटरटेनमेंट डेस्क",
        date: "02 जन 2026",
        readTime: "4 मिनट पढ़ें",
        fullNews: `इस साल बॉक्स ऑफिस पर कई बड़ी फिल्में रिलीज होने जा रही हैं।
दर्शक इन फिल्मों का बेसब्री से इंतजार कर रहे हैं।`,
    }
];

export const politicsNews = [
    {
        image: "https://www.jagranimages.com/images/newimg/03092025/03_09_2025-bjp_meeting_24034886.webp",
        category: "राजनीति",
        title: "चुनावों से पहले संगठनात्मक बदलाव, बीजेपी में मंथन",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `चुनावों से पहले संगठनात्मक स्तर पर बदलाव की संभावना जताई जा रही है।
पार्टी सूत्रों के मुताबिक, जल्द ही फैसले लिए जा सकते हैं।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202407/66a5cbe278c52-bjp-cms-meet-284105115-16x9.png?size=948:533",
        category: "राजनीति",
        title: "बीजेपी में संगठन को मजबूत करने पर जोर",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `पार्टी नेतृत्व का फोकस संगठन को मजबूत करने पर है।
जिलों में बैठकों और समीक्षाओं का दौर जारी है।`,
    },
    {
        image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202201/bjp_1-sixteen_nine-sixteen_nine.jpg",
        category: "राजनीति",
        title: "आगामी चुनावों के लिए पार्टी की रणनीति तैयार",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `आगामी चुनावों को ध्यान में रखते हुए रणनीति बनाई जा रही है।
पार्टी स्तर पर बैठकों का दौर जारी है।`,
    },
    {
        image: "https://images.moneycontrol.com/static-mcnews/2024/05/20240502115944_200241-yzevpqohut-1713861432-1-770x404.jpeg?impolicy=website&width=770&height=431",
        category: "राजनीति",
        title: "2026 चुनावों से पहले बीजेपी की रणनीति, संगठनात्मक बदलाव संभव",
        author: "पॉलिटिकल डेस्क",
        date: "03 जन 2026 18:10 IST",
        readTime: "3 मिनट पढ़ें",
        fullNews: `2026 विधानसभा चुनावों से पहले बीजेपी संगठन में बदलाव की जोरदार चर्चा है।
सूत्रों के अनुसार, कई जिलों में नई जिम्मेदारियां सौंपी जा सकती हैं।`,
    },
];

export const webStories = [{
        id: 1,
        category: "मौसम",
        slides: [
            { image: "https://www.livehindustan.com/lh-img/smart/img/2025/06/13/1200x900/uttarakhand_rain_1744259893841_1749778376405.jpg", heading: "एमपी में मौसम बदला" },
            { image: "https://img.naidunia.com/naidunia/ndnimg/02092024/02_09_2024-mohan_cabinet_3_sep_202492_22258.webp", heading: "कई जिलों में बारिश का अलर्ट" }
        ]
    },
    {
        id: 2,
        category: "शिक्षा",
        slides: [
            { image: "https://www.livehindustan.com/lh-img/smart/img/2025/02/13/1000x563/board_exam_3_1738383392152_1739457791917.jpg", heading: "सीबीएसई बोर्ड परीक्षा अपडेट" },
            { image: "https://img-cdn.publive.online/fit-in/640x430/filters:format(webp)/bansal-news/media/media_files/2025/12/18/up-school-timing-change-2025-12-18-10-13-07.jpg", heading: "परीक्षा केंद्रों पर कड़ी सुरक्षा व्यवस्था" }
        ]
    },
    {
        id: 3,
        category: "राजनीति",
        slides: [
            { image: "https://cf-img-a-in.tosshub.com/lingo/nwtak/images/story/202511/6913fdbc6ae21-while-colabas-voter-turnout-was-low--it-still-showed-a-slight-improvement-compared-to-kalyan-west-201209912-16x9.jpeg?size=768:432&q=50", heading: "इंदौर वोटिंग रिकॉर्ड" },
            { image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202201/bjp_1-sixteen_nine-sixteen_nine.jpg", heading: "रिकॉर्ड वोटिंग के बाद नतीजों का इंतजार" }
        ]
    },
    {
        id: 4,
        category: "बिजनेस",
        slides: [
            { image: "https://images.moneycontrol.com/static-mcnews/2024/05/20240502115944_200241-yzevpqohut-1713861432-1-770x404.jpeg?impolicy=website&width=770&height=431", heading: "शेयर बाजार में भारी उछाल" },
            { image: "https://th-i.thgim.com/public/incoming/xy2ju0/article67931771.ece/alternates/FREE_1200/PTI03_09_2024_000073B.jpg", heading: "निवेशकों में खुशी की लहर" }
        ]
    },
    {
        id: 5,
        category: "मनोरंजन",
        slides: [
            { image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?auto=format&fit=crop&w=800&q=80", heading: "सिनेमा जगत से बड़ी खबर" }
        ]
    },
    {
        id: 6,
        category: "तकनीक",
        slides: [
            { image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80", heading: "एआई का बढ़ता प्रभाव" }
        ]
    },
    {
        id: 7,
        category: "खेल",
        slides: [
            { image: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?auto=format&fit=crop&w=800&q=80", heading: "क्रिकेट: नया रिकॉर्ड" }
        ]
    },
    {
        id: 8,
        category: "लाइफस्टाइल",
        slides: [
            { image: "https://images.unsplash.com/photo-1505909182942-e2f09aee3e89?auto=format&fit=crop&w=800&q=80", heading: "नए फिटनेस टिप्स" }
        ]
    }
];

export const technologyNews = [
    {
        image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80",
        category: "तकनीक/विज्ञान",
        title: "नई तकनीक ने बदली दुनिया, एआई का बढ़ता प्रभाव",
        author: "टेक डेस्क",
        date: "04 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `आर्टिफिशियल इंटेलिजेंस (AI) के क्षेत्र में हो रहे नए आविष्कारों ने काम करने के तरीके में क्रांति ला दी है।`
    },
    {
        image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=800&q=80",
        category: "तकनीक/विज्ञान",
        title: "नया स्मार्टफोन लॉन्च, जानें कीमत और फीचर्स",
        author: "टेक डेस्क",
        date: "03 जन 2026",
        readTime: "2 मिनट पढ़ें",
        fullNews: `बाजार में एक नया स्मार्टफोन लॉन्च किया गया है, जो अपने शानदार फीचर्स और बजट कीमत के लिए चर्चा में है।`
    },
    {
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80",
        category: "तकनीक/विज्ञान",
        title: "इसरो ने लॉन्च किया नया सैटेलाइट, संचार व्यवस्था होगी मजबूत",
        author: "साइंस डेस्क",
        date: "02 जन 2026",
        readTime: "4 मिनट पढ़ें",
        fullNews: `भारतीय अंतरिक्ष अनुसंधान संगठन (ISRO) ने आज श्रीहरिकोटा से एक नया संचार उपग्रह सफलतापूर्वक लॉन्च किया।`
    },
    {
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80",
        category: "तकनीक/विज्ञान",
        title: "नए 6G नेटवर्क की टेस्टिंग शुरू, मिलेगी 100 गुना ज्यादा स्पीड",
        author: "टेक डेस्क",
        date: "01 जन 2026",
        readTime: "3 मिनट पढ़ें",
        fullNews: `दुनिया भर की प्रमुख टेक कंपनियों ने 6G तकनीक पर काम करना शुरू कर दिया है।`
    }
];